import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import EpisodeReaction from '../../../domain/entities/EpisodeReaction';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexEpisodeReactionsSuccess: {
      const result = action.payload as PaginatedResult<EpisodeReaction>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
